import script from "./UiEmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiEmptyState.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./UiEmptyState.vue?vue&type=style&index=0&id=6d34b50a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__